export default __webpack_public_path__ + "static/Made_from_Recycled_Materials-31907a5ad3e1a1ac429a0704f07ec16b.svg";